export default __webpack_public_path__ + "static/media/mysql.d6359ca4.png";